module.exports = __webpack_public_path__ + "img/video.39d36ca7.png";